import React, { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "./Followers.css";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../routes/history";
import FollowerViewItem from "../../../components/FollowerViewItem/FollowerViewItem";
import Loader from "../../../components/Loading/Loader";
import { getFollowersV2 } from "../../../API/API";
import { useParams } from "react-router-dom/cjs/react-router-dom";

export default function Followers() {
  const params = useParams();
  console.log("params ", params);
  const dispatch = useDispatch();

  const [followers, setFollowers] = useState([]);

  // const followers = useSelector((state) => state.getFollowersReducer.followers);
  const loading = useSelector((state) => state.getFollowersReducer.loading);
  const error = useSelector((state) => state.getFollowersReducer.error);

  function getFollowers() {
    getFollowersV2({ id: params.id })
      .then((res) => {
        setFollowers(res.data.followers);
      })
      .catch((error) => {
        console.log("error ", error);
      });
  }

  useEffect(() => {
    getFollowers();
  }, []);

  if (loading) {
    //|| followers?.length === 0
    return (
      <div>
        <Loader />
      </div>
    );
  } else {
    return (
      <React.Fragment>
        <main className="followers_main">
          <div>
            <ArrowLeftOutlined
              className="backarrow_followers"
              onClick={() => history.goBack()}
            />
          </div>

          <div className="followersTitle">Followers</div>
          <p className="itemsLength">{followers?.length} items</p>
          {/* <div> */}
            <Row>
              {/* <Row style={{display: 'flex', justifyContent: 'space-between', background: 'red'}}>    */}
              {followers && followers?.length ? (
                followers?.map((item, index) => {
                  return (
                    <Col xs={24} sm={24} md={24} lg={6} xl={6}>
                      <div className="follower-wb">
                        {/* <div style={{width:'93%'}}> */}
                        <FollowerViewItem
                          name={
                            item.follower_profile.Profiles.FirstName +
                            " " +
                            item.follower_profile.Profiles.LastName
                          }
                          location={
                            item?.follower_profile?.Profiles?.Location
                              ?.LocationWithCountry
                          }
                          views={
                            item?.follower_profile?.Profiles.ProfileViews.length
                          }
                          Key={item?.follower_profile?.Profiles?.PictureUrl}
                          index={index}
                        />
                      </div>
                    </Col>
                  );
                })
              ) : (
                <div className="no-follower-data">No data found</div>
              )}
            </Row>
          {/* </div> */}
        </main>
      </React.Fragment>
    );
  }
}
